import { render, staticRenderFns } from "./RinvProfit.vue?vue&type=template&id=3125d6c2"
import script from "./RinvProfit.vue?vue&type=script&lang=js"
export * from "./RinvProfit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports